import { faLocationDot, faPhone } from '@fortawesome/free-solid-svg-icons';
import { Box } from '@mui/material';
import { FormattedMessage } from 'react-intl';

import {
  ContactsContainerStyled,
  ContactsStyled,
  FontAwesomeIconStyled,
  InfoContainer,
  TypographyStyled,
} from './ContactsHemera.styles';
import { SocialNetworksHemera } from './SocialNetworks';

export const ContactsHemera = () => (
  <ContactsContainerStyled>
    <Box>
      <ContactsStyled>
        <FormattedMessage id="TRLT_UI-CONTACTS" />
      </ContactsStyled>

      <InfoContainer>
        <FontAwesomeIconStyled icon={faPhone} />
        <TypographyStyled id="hemeraPhoneNumber">
          <FormattedMessage id="TRLT_UI-PHONE_NUMBER_HEMERA" />
        </TypographyStyled>
      </InfoContainer>
      <InfoContainer>
        <FontAwesomeIconStyled icon={faLocationDot} />
        <TypographyStyled>
          <FormattedMessage id="TRLT_UI-ADRESSE_HEMERA" />
        </TypographyStyled>
      </InfoContainer>
    </Box>
    <SocialNetworksHemera />
  </ContactsContainerStyled>
);
